import { useState } from 'react';

import { useLocalStorage } from '@mantine/hooks';

interface PaginationState {
	pageSize: number;
	pageIndex: number;
}

export const usePersistentPagination = (
	key: string,
	initialState: PaginationState = { pageSize: 10, pageIndex: 0 }
) => {
	const [pageSize, setPageSize] = useLocalStorage({
		defaultValue: initialState.pageSize,
		key: `${key}-page-size`,
		getInitialValueInEffect: false,
	});
	const [pageIndex, setPageIndex] = useState(initialState.pageIndex);

	const setPagination = (newState: PaginationState | ((prev: PaginationState) => PaginationState)) => {
		const newValue = typeof newState === 'function' ? newState({ pageSize, pageIndex }) : newState;

		setPageSize(newValue.pageSize);
		setPageIndex(newValue.pageIndex);
	};

	return [{ pageSize, pageIndex }, setPagination] as const;
};
